import React from 'react'
import { useNavHierarchyRetailer } from '../../NavMenuHierarchy'
import { LeftShortcutsPane } from './LeftShortcutsPane'

export const LeftShortcutsPaneRetailer: React.FC = () => {
  const { indexedL1ByRoutes } = useNavHierarchyRetailer()

  return <LeftShortcutsPane indexedL1ByRoutes={indexedL1ByRoutes} />
}
